var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-switch"},[_c('itemSearch',_vm._b({},'itemSearch',_vm.$attrs,false),[_c('el-switch',_vm._b({on:{"change":_vm.change},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'el-switch',_vm.$attrs,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }